import type { UseFormReturn } from 'react-hook-form';
import type { ProgramListingItemGroup } from '../ProgramListing/utils';
import type { AssessmentRunsFormData } from './AssessmentRunsFormConfig';
import AssessmentRunsSettingsStep from './steps/AssessmentRunsSettingsStep';
import ReviewAssessmentRunsStep from './steps/ReviewAssessmentRunsStep';
import type { FormMode } from './useAssessmentRunsFormState';
import type { ProgramListItemDataFragment } from '@/gql/graphql';

interface StepRendererProps {
    step: number;
    mode: FormMode;
    form: UseFormReturn<AssessmentRunsFormData>;
    program?: ProgramListItemDataFragment | null;
    selectedGroup?: ProgramListingItemGroup | null;
    onSubmit: () => void;
    onNext: () => void;
    onPrev: () => void;
    onClose: () => void;
}

const StepRenderer = ({
    step,
    form,
    mode,
    program,
    selectedGroup,
    onNext,
    onPrev,
    onClose,
    onSubmit,
}: StepRendererProps) => {
    switch (step) {
        case 1:
            return (
                <AssessmentRunsSettingsStep
                    form={form}
                    mode={mode}
                    program={program}
                    selectedGroup={selectedGroup}
                    onNext={onNext}
                    onClose={onClose}
                />
            );
        case 2:
            return <ReviewAssessmentRunsStep program={program} onPrev={onPrev} onSubmit={onSubmit} />;
        default:
            return null;
    }
};

export default StepRenderer;
